import DashboardLogItem from './DashboardLogItem';

export default DashboardLogItem;
